'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _face = require('../../face');

function defaultValueFormatter(value, state) {
  if ((0, _lodash.isNil)(value)) {
    return (0, _face.getButtonNameByStatus)(_face.STATUS_MAP.INIT, '未授权');
  }
  var result = (0, _face.getStatusByScanResult)(value.result);
  return (0, _face.getButtonNameByStatus)(result);
}

exports.default = { defaultValueFormatter: defaultValueFormatter };
module.exports = exports['default'];